import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Logo } from './ui/Logo';
import { Button } from './ui/Button';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) { return { error }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('AccheyRishtey page error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="error-page"><Logo/><div className="empty-state__arch">AR</div><h1>Something went wrong on this page</h1><p>Your data is safe. Try loading the page again, or return to the dashboard.</p><div className="button-row"><Button onClick={() => this.setState({ error: null })}>Try again</Button><a className="button button--secondary" href="/dashboard"><span>Back to dashboard</span></a></div></main>;
  }
}
